import './layout.scss';

import React from 'react';
import { Outlet } from 'react-router-dom';

import { useAppSelector } from '@/app/store/hooks';
import { selectHasLockedBonus } from '@/entities/user';
import { useCloseModalsOnNavigation } from '@/shared/lib/hooks/useCloseModalsOnNavigation';
import { useScrollToTop } from '@/shared/lib/hooks/useScrollToTop';
import { Footer } from '@/widgets/Footer';
import { Header } from '@/widgets/Header';

export const Layout: React.FC = () => {
  useScrollToTop();
  useCloseModalsOnNavigation();

  const hasLockedBonus = useAppSelector(selectHasLockedBonus);

  return (
    <div className={`layout${hasLockedBonus ? ' layout--with-bonus' : ''}`}>
      <Header />
      <main className="layout__main scrollbar-hide">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
